import { notification } from "antd";

const NOTIFICATION_ROOT_ID = "app-notification-root";
const MODAL_CLOSE_DELAY_MS = 450;

let configured = false;

const ensureNotificationRoot = () => {
  let root = document.getElementById(NOTIFICATION_ROOT_ID);

  if (!root) {
    root = document.createElement("div");
    root.id = NOTIFICATION_ROOT_ID;
    document.body.appendChild(root);
  }

  return root;
};

export const configureNotifications = () => {
  if (configured) {
    return;
  }

  configured = true;
  ensureNotificationRoot();

  notification.config({
    placement: "topRight",
    top: 24,
    duration: 3,
    maxCount: 4,
    getContainer: () => ensureNotificationRoot(),
  });
};

const showSuccessWhenLayoutStable = (config) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      notification.success({
        ...config,
        style: { marginBottom: 16, ...config?.style },
      });
    });
  });
};

/** Show success toast after modal close animation and body layout settle. */
export const notifySuccessAfterModalClose = (config) => {
  window.setTimeout(() => {
    showSuccessWhenLayoutStable(config);
  }, MODAL_CLOSE_DELAY_MS);
};

if (typeof document !== "undefined") {
  configureNotifications();
}
